<template>
  <div class="meters-bag">
    <div class="meter-card" v-for="( meter, index ) in selected_region.meters" :key="index"
      :class="{ 'selected': edit_meter_data.id === meter.id }" @click="selectMeter(meter)" @touchstart="handleTouchStart"
      @touchend="handleTouchEnd" :style="cardBackground(meter)">
      <div class="meter-name">
        {{ meter.mac_alias ?? meter.bx_mac }}
      </div>
      <div class="btn-bag">
        <button type="button" id="popup-window" class="btn btn-success btn-sm" @click.stop="openModal(meter)">
          <i class="fa-regular fa-pen-to-square"></i>
        </button>
      </div>
    </div>
    <edit-meter />
  </div>
</template>

<script>
import EditMeter from '../modal/EditMeter.vue';

export default {
  data() {
    return {
      base_url,
      show_input: false,
      alias: '',
      timeout_id: null,
      edit_meter_data: '',
    };
  },
  mounted() {
    console.log('--select-meter-- mounted');
    if (this.meter.id) {
      this.edit_meter_data = this.meter;
    }
  },
  computed: {
    selected_region() {
      return this.$store.getters.selectedRegion;
    },
    meter() {
      return this.$store.getters.selectedMeter;
    },
  },
  watch: {
    selected_region() {
      let card_num = 4;
      window.innerWidth < 768 ? card_num = 2 : card_num = 4;
      let is_meter_overflow = Object.keys(this.selected_region.meters).length > card_num;
      if (this.selected_region.meters && is_meter_overflow) {
        this.$el.classList.add('scrollbar');
      }
      this.edit_meter_data = this.selected_region.meters[0];
    },
    meter() {
      this.edit_meter_data = this.meter;
    },
    deep: true,
  },
  methods: {
    cardBackground(meter) {
      if (meter.image) {
        return `background-image: url(${base_url}${meter.image})`;
      } else {
        return `background-image: url(${base_url}/images/def_meter.jpg)`;
      }
    },
    handleTouchStart(event) {
      // 防止觸發多次
      if (this.timeout_id) {
        clearTimeout(this.timeout_id);
      }
      this.timeout_id = setTimeout(() => {
        this.openModal(event);
      }, 500); // 500毫秒定義為長按
    },
    handleTouchEnd(event) {
      // 手指離開時清除計時器
      if (this.timeout_id) {
        clearTimeout(this.timeout_id);
      }
    },
    openModal(meter) {
      this.edit_meter_data = meter;
      const modal = this.$el.querySelector('#meterModal');
      const blur_bg = this.$el.querySelector('.blur-bg');
      modal.style.display = 'block';
      modal.classList.add('show');
      blur_bg.style.display = 'block';
      modal.addEventListener('click', (e) => {
        if (e.target.id === 'meterModal') {
          this.closeModal();
        }
      });
    },
    closeModal() {
      const modal = this.$el.querySelector('#meterModal');
      const blur_bg = this.$el.querySelector('.blur-bg');
      modal.style.display = 'none';
      modal.classList.remove('show');
      blur_bg.style.display = 'none';
    },
    async selectMeter(meter) {
      if (this.edit_meter_data.id !== meter.id) {
        console.log('--select-meter-- meter changed');
        this.edit_meter_data = meter;
        await this.$store.dispatch('setRequestDate', meter.bx_mac);
        console.log('--select-meter-- end set requestDate');
        this.$store.dispatch('setSelectedMeter', meter.id);
      }
    },
  },
  components: { EditMeter }
};
</script>

<style scoped>
.meters-bag {
  display: flex;
  align-content: flex-start;
  flex-wrap: wrap;
  padding-bottom: 3%;
}

.scrollbar {
  overflow-x: scroll;
  flex-direction: column;
}

.scrollbar::-webkit-scrollbar {
  height: 8px;
}

.scrollbar::-webkit-scrollbar-track {
  background-color: var(--bx-blur);
  border-radius: 10px;
  margin: 200px 200px;
}

.scrollbar::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: var(--bx-green);
}


.meters-bag .meter-card {
  cursor: pointer;
  background-size: cover;
  background-position: center;
  border-radius: 1rem;
  margin: .5% 2% 2% 2%;
  width: 45%;
  height: 43%;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  transition: 0.1s;
  display: flex;
  position: relative;
}

.meters-bag .meter-card.selected {
  border: 3px solid var(--bx-green);
  transform: scale(1.03);
  box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.meters-bag .meter-card:hover {
  border: 3px solid var(--bx-green);
  transform: scale(1.05);
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.meters-bag .meter-card:hover .btn-bag {
  display: flex;
}

.meters-bag .meter-card .meter-name {
  position: absolute;
  color: white;
  font-weight: bolder;
  bottom: 0;
  left: 0;
  padding: 5%;
  text-shadow: 2px 2px 4px #000000;
}

.meters-bag .meter-card .btn-bag {
  position: absolute;
  right: 0;
  top: 0;
  display: none;
  transition: 0.3s;
}

.meters-bag .meter-card .btn-bag .btn {
  border-radius: 0 .7rem 0 .25rem;
}

.meters-bag .meter-card .btn-bag .btn-info {
  color: white;
  font-weight: bolder;
}

@media (max-width: 1150px) {
  .meters-bag .meter-card .meter-name {
    font-size: .8rem;
  }
}

@media (max-width: 768px) {
  .meters-bag .meter-card {
    width: 45%;
    height: 90%;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0);
  }

  .meters-bag .meter-card.selected {
    box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0);
  }

  .scrollbar::-webkit-scrollbar {
    height: 4px;
  }

  .scrollbar::-webkit-scrollbar-track {
    margin: 200px 150px;
  }
}
</style>
